
import { defineComponent } from 'vue';
import { useList } from '@/hooks/use-list';
import CreatedNotice from './components/create-notice/index.vue';
import DetailDialog from './components/detail-dialog/index.vue';
import { _CreatedNotice } from './composable/useContentInfo';
import { NOTICE_TYPE_ENUM, NOTICE_TYPE_LIST, OPERATION_TYPE_ENUM } from './constant/index';
import {
  INoticePageResListItem,
  INoticePageReq,
} from '@/api/content-manage/type.d';
import { noticePage } from '@/api/content-manage';
import usePermissionConfig from './use-permission-config';
import { formatTime } from '@toy/utils';

export default defineComponent({
  components: {
    CreatedNotice,
    DetailDialog,
  },
  setup() {
    const permissionConfig = usePermissionConfig();
    const {
      params,
      tableTotal,
      tableData,
      handleSizeChange,
      handleCurrentChange,
      handleReset,
      handleSearch,
    } = useList<INoticePageResListItem, INoticePageReq>({
      request: {
        api: noticePage,
        params: {
          noticeCode: '',
          theme: '',
          status: '',
          creatorName: '',
          startPublishTime: '',
          endPublishTime: '',
          pageNum: 1,
          pageSize: 10,
          noticeTime: [],
        },
        handleParams(paramsObj) {
          // 处理时间
          if (paramsObj.noticeTime && paramsObj.noticeTime.length === 2) {
            [paramsObj.startPublishTime, paramsObj.endPublishTime] = [
              `${formatTime(
                paramsObj.noticeTime[0],
                'YYYY-MM-DD',
              )} 00:00:00`,
              `${formatTime(
                paramsObj.noticeTime[1],
                'YYYY-MM-DD',
              )} 23:59:59`,
            ];
          }
          delete paramsObj.noticeTime;
          if (typeof paramsObj.pageNum !== 'number') {
            paramsObj.pageNum = 1;
          }
          return paramsObj;
        },
      },
    });
    const {
      createdNoticeVisible,
      detailVisible,
      noticeItem,
      handleIncreased,
      handleNoticeEdit,
      handleNoticeDetail,
      handleStart,
      handleUndo,
      handleComplete,
      dialogVisible,
      message,
      handleOperationCallBack,
    } = _CreatedNotice();
    handleSearch();
    return {
      params,
      tableData,
      tableTotal,
      createdNoticeVisible,
      detailVisible,
      handleSizeChange,
      handleCurrentChange,
      handleReset,
      handleSearch,
      handleIncreased,
      handleNoticeEdit,
      handleNoticeDetail,
      handleStart,
      handleUndo,
      handleComplete,
      permissionConfig,
      noticeItem,
      NOTICE_TYPE_ENUM,
      OPERATION_TYPE_ENUM,
      NOTICE_TYPE_LIST,
      dialogVisible,
      message,
      handleOperationCallBack,
    };
  },
});
